module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_3.ed54ae92.png";